import { JobDetailResponse } from '@doda/api-client/aspida/@types';
import React from 'react';
import dynamic from 'next/dynamic';
import { ManuscriptT } from './ManuscriptT';
import { ManuscriptA } from './ManuscriptA';
import { ManuscriptB } from './ManuscriptB';
import { ManuscriptC } from './ManuscriptC';
import { ManuscriptD } from './ManuscriptD';
import { Tab as TabType } from '../../../types/tab';

const DynamicManuscriptE = dynamic(() =>
  import('./ManuscriptE').then((module) => ({ default: module.ManuscriptE }))
);

/**
 * JobDetailのProps
 */
export interface JobDetailProps {
  job: JobDetailResponse;
  isScout: boolean;
}

/**
 * useTabに必要なProps
 */
export interface TabProps {
  wcnsId: string;
  initialTab: TabType;
  isApplied: boolean;
}

/**
 * A~T原稿を出し分けするためのコンポーネント
 */
export const JobDetail: React.FC<JobDetailProps & TabProps> = ({
  job,
  isScout,
  wcnsId,
  initialTab,
  isApplied,
}) => {
  const manuscriptType = job.job?.wcnsId;

  if (manuscriptType === 'A')
    return <ManuscriptA job={job} isScout={isScout} />;
  if (manuscriptType === 'B')
    return <ManuscriptB job={job} isScout={isScout} />;
  if (manuscriptType === 'C')
    return <ManuscriptC job={job} isScout={isScout} />;
  if (manuscriptType === 'D')
    return <ManuscriptD job={job} isScout={isScout} />;
  if (manuscriptType === 'E')
    return <DynamicManuscriptE job={job} isScout={isScout} />; // 動画を含む場合がある為、初期ロードを軽減させる
  return (
    <ManuscriptT
      job={job}
      isScout={isScout}
      wcnsId={wcnsId}
      initialTab={initialTab}
      isApplied={isApplied}
    />
  );
};
